export const menu = [
  {
    title: 'Home',
    link: '/',
  },
  {
    title: 'Our Firm',
    link: '/firm',
  },
  {
    title: 'About Us',
    link: '/about',
  },
  {
    title: 'TASA Obligations',
    link: '/tasa-obligations',
  },
  {
    title: 'Compliance',
    link: '/compliance',
  },
  {
    title: 'Consulting',
    link: '/consulting',
  },
  {
    title: 'Pricing',
    link: '/pricing',
  },

  {
    title: 'Contact',
    link: '/contact',
  },
];

export default {
  menu,
};
